import {Button} from "@mui/material";
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {useAsyncAction} from "nate-react-api-helpers";

export function TaskTitle(props: {
    value: string;
    onChange(value: string): Promise<any>
}) {
    const [editValue, setEditValue] = useState(props.value);
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        setEditValue(props.value);
    }, [props.value]);

    const update = useAsyncAction(props.onChange, [props.onChange]);

    return (
        <div>
            <input value={editValue}
                   onChange={(e) => setEditValue(e.currentTarget.value)}
                   onFocus={() => setFocused(true)}
                   onBlur={() => setFocused(false)}
                   className={titleCls}
            />
            {(editValue !== props.value || focused) && <div style={{
                paddingTop: 4,
            }}>
                <Button variant="contained" onClick={() => update.callback(editValue)}>Save</Button>
                <Button onClick={() => {
                    setEditValue(props.value);
                }}>Cancel</Button>
                {update.LoadingElement}
            </div>}
        </div>
    )
}

const titleCls = css({
    flex: 1,
    border: "1px solid transparent",
    fontSize: "1.2rem",
    width: "100%",

    "&:focus": {
        border: "1px solid " + grey["300"],
        paddingTop: 4,
        paddingBottom: 4,
    }
})